import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'nx-ng-basket',
  templateUrl: './basket.component.html',
  styleUrls: ['./basket.component.scss'],
})
export class BasketComponent {
  @Input()
  basketItemsTotal = 0;

  @Output()
  basketClick: EventEmitter<void> = new EventEmitter<void>();

  handleClick(): void {
    this.basketClick.emit();
  }
}
